import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { Roles } from 'src/assets/static-data/enums/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {
  
  isDriverRole:boolean=false;

  constructor(private router: Router,
    private authService: AuthService,
    private userService: UserService) {
      this.isDriverRole=this.authService.isDriverUserValue;
  }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot){
      const currentUser = this.authService.currentUserValue;
      if (!currentUser) {
          //logged in so return false
          return false;
      }
      if(this.isDriverRole)
      {
        this.router.navigate(['/driver-trips'])
      }
      return true
  }
}
